const AUTH_ONBOARDED_STORAGE_KEY = 'auth:onboarded';

const isBrowser = () => typeof window !== 'undefined';

const getSessionStorage = (): Storage | null => {
  if (!isBrowser()) return null;
  return window.sessionStorage;
};

const getLocalStorage = (): Storage | null => {
  if (!isBrowser()) return null;
  return window.localStorage;
};

export const authBrowserStorage = {
  setOnboarded(onboarded: string) {
    const storage = getSessionStorage();
    if (!storage) return;

    if (storage.getItem(AUTH_ONBOARDED_STORAGE_KEY) === null) {
      storage.setItem(AUTH_ONBOARDED_STORAGE_KEY, onboarded);
    }
  },

  clear() {
    const sessionStorage = getSessionStorage();
    sessionStorage?.removeItem(AUTH_ONBOARDED_STORAGE_KEY);

    // Remove legacy keys left from the old unnamespaced approach.
    const localStorage = getLocalStorage();
    localStorage?.removeItem('token');
    localStorage?.removeItem('onboarded');
  },
};
